import React from 'react';
import { Image, Text, View, TouchableOpacity } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient'
import HeaderTabs from '../../components/HeaderTabs';
import styles from './styles';

const MyQualification = ({ navigation }) => {
    return (
        <>
            <HeaderTabs
                title={"MEU NÍVEL"}
                iconLeft={"keyboard-arrow-left"}
                subtitle={"Saiba como garantir mais vantagens"}
            />

            <View style={styles.container}>
                <View style={styles.outsideEdge}>
                    <View style={styles.innerEdge}>
                        <Image source={require('../../../assets/imgs/medal.png')} style={styles.imgMedal} />
                        <Text style={styles.level}>2</Text>
                    </View>
                </View>

                <View style={styles.contentTimeline}>
                    <View style={styles.stepConcluded} />
                    <View style={styles.stepLineConcluded} />
                    <View style={styles.stepConcluded} />
                    <View style={styles.stepLineNoConcluded} />
                    <View style={styles.stepNoConcluded} />
                </View>
                <Text style={styles.descriptionLevel}>
                    Você está no nível 2
                </Text>
                {/*
                <Text style={styles.descriptionLevel}>
                    Você já possui 50% das qualificações para ser considerado um usuário Nível Premium
                </Text>

                <Text style={styles.nextSteps}>Próximos passos</Text>

                <View style={styles.contentDescriptionNextSteps}>
                    <Text>{"\u2022"} Realize transações completas no prazo de 30 dias</Text>
                    <Text>{"\u2022"} Feche acordos na exchange</Text>
                    <Text>{"\u2022"} Pague com GPX Token pelo aplicativo e acumule R$500,00 por mês nos próximos 3 meses</Text>
                </View>

                <Text style={styles.premiumBenefits}>Benefícios de ser Premium</Text>

                <View style={styles.contentDescriptionPremiumBenefits}>
                    <Text>{"\u2022"} Usuário Premium pode realizar compras acima de XXX.XXX,00BRL</Text>
                    <Text>{"\u2022"}  A cada XXX (valor) adquiridos você recebe automaticamente X% em cashback</Text>
                </View> */}
                <View style={styles.contentBtn}>
                    <TouchableOpacity style={styles.button} onPress={() => navigation.navigate('LevelUpdate')}>
                        <LinearGradient
                            start={{ x: -1, y: 0 }}
                            end={{ x: 1, y: 0 }}
                            colors={["#16195B", "#1FBFB5"]}
                            style={styles.btn}>
                            <Text style={styles.textBtn}>Atualização de nível</Text>
                        </LinearGradient>
                    </TouchableOpacity>
                </View>
            </View>
        </>
    );
}

export default MyQualification;